var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCount = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "46px",
  height: "53px",
  viewBox: "0 0 46 53",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "count") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "count",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.8138977,51 L25.9765377,37.8750125 L15.0390482,37.8750125 L12.8764082,51 L5.91618754,51 L8.07882752,37.8750125 L0.870027579,37.8750125 L2.03835033,30.9147919 L9.22229234,30.9147919 L10.9623475,20.1761658 L3.82812135,20.1761658 L4.97158617,13.2159451 L12.1058123,13.2159451 L14.2684523,0.0909576416 L21.2286729,0.0909576416 L19.066033,13.2159451 L30.0035225,13.2159451 L32.1661625,0.0909576416 L39.1263831,0.0909576416 L36.9637432,13.2159451 L44.1476852,13.2159451 L43.0042204,20.1761658 L35.8202783,20.1761658 L34.0802232,30.9147919 L41.2144493,30.9147919 L40.0461266,37.8750125 L32.9367584,37.8750125 L30.7741184,51 L23.8138977,51 Z M16.182513,30.9147919 L27.1200025,30.9147919 L28.8600577,20.1761658 L17.9225681,20.1761658 L16.182513,30.9147919 Z",
  id: "#-copy",
  fill: "#000000"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/count.9588893c3f00eb2cd25185fb82e76986.svg";